import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-book-open-line text-2xl ${isScrolled || !isHome ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span className={`text-lg font-bold ${isScrolled || !isHome ? 'text-foreground-950' : 'text-background-50'}`}>
              韩漫之家
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                isScrolled || !isHome ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/category/romance"
              className="hidden md:flex items-center gap-2 bg-primary-500 text-background-50 px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-fire-line"></i>
              开始阅读
            </Link>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-2xl ${isScrolled || !isHome ? 'text-foreground-950' : 'text-background-50'}`}>
                {isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}
              </i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 py-4 animate-[fadeIn_0.2s_ease-out]">
            <div className="flex flex-col gap-2 px-2">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-foreground-700 hover:text-primary-500 text-sm font-medium px-3 py-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-foreground-700 hover:text-primary-500 text-sm font-medium px-3 py-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-foreground-700 hover:text-primary-500 text-sm font-medium px-3 py-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
              >
                关于我们
              </Link>
              <Link
                to="/category/romance"
                onClick={() => setIsMobileMenuOpen(false)}
                className="bg-primary-500 text-background-50 text-sm font-semibold px-5 py-2.5 rounded-full text-center whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer mt-2"
              >
                开始阅读
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}